import {
  applySnapshot, flow, getEnv, types,
} from 'mobx-state-tree';
import { toast } from 'react-hot-toast';
import {
  BecomePartner,
  BecomePartnerValues,
  BecomePartnerListData,
  ListMetaDataModel,
} from '../types';
import { DEFAULT_META } from '../constants';

export const BecomePartnerStoreModel = types.model('BecomePartnerStore', {
  items: types.optional(types.array(types.frozen<BecomePartner>()), []),
  meta: types.optional(ListMetaDataModel, DEFAULT_META),
})
  .actions((self) => ({
    fetchBecomePartners: flow(function* (params) {
      try {
        const res = yield getEnv(self).api.fetchBecomePartners(params);
        const { items, meta } = res as BecomePartnerListData;
        applySnapshot(self.items, items);
        self.meta = meta;
      } catch (e) {
        toast.error('Failed to fetch contact messages');
      }
    }),
    fetchBecomePartnerById: flow(function* (id: string) {
      try {
        const res = yield getEnv(self).api.fetchBecomePartnerById(id);
        applySnapshot(self.items, [res]);
      } catch (e) {
        toast.error('Failed to fetch contact message');
      }
    }),
    updateBecomePartner: flow(function* (id: string, data: BecomePartnerValues) {
      try {
        yield getEnv(self).api.updateBecomePartner(id, data);
        toast.success('Contact message updated');
      } catch (e) {
        toast.error('Failed to update contact message');
      }
    }),
  }))
  .views((self) => ({
    // eslint-disable-next-line max-len
    getBecomePartnerById: (id: string): BecomePartner | undefined => self.items.find((item) => item.id === Number(id)),
  }));

// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
export const createBecomePartnerStoreModel = () => types.optional(BecomePartnerStoreModel, {});
